import StocksAndSecuritiesGuard from "./StocksAndSecuritiesGuard";
import { lazy } from "react";
import { R_SSRoutes } from "../../utils/Routes";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";

const SsDetailsPage = lazy(() => import("./DetailsPage/SsDetailsPage"));
const MyDocuments = lazy(() => import("./MyDocuments/MyDocuments"));
const AccountStatement = lazy(
  () => import("./AccountStatement/AccountStatement"),
);

const StocksSecuritiesRoutesFn = () => {
  return [
    {
      path: R_SSRoutes.details_baseUrl,
      element: <StocksAndSecuritiesGuard />,
      children: [
        {
          path: R_SSRoutes.details_Portfolio,
          element: <SuspenseWrapper LazyLoadingComponent={SsDetailsPage} />,
        },
        {
          path: R_SSRoutes.details_Portfolio_MyDocuments,
          element: <SuspenseWrapper LazyLoadingComponent={MyDocuments} />,
        },
        {
          path: R_SSRoutes.account_statement,
          element: <SuspenseWrapper LazyLoadingComponent={AccountStatement} />,
        },
        {
          path: R_SSRoutes.contact_notes,
          element: <SuspenseWrapper LazyLoadingComponent={AccountStatement} />,
        },
      ],
    },
  ];
};
export { StocksSecuritiesRoutesFn };
